import { render } from "./ModalGratitude.vue?vue&type=template&id=3f307dda&scoped=true&ts=true"
import script from "./ModalGratitude.vue?vue&type=script&lang=ts"
export * from "./ModalGratitude.vue?vue&type=script&lang=ts"

import "./ModalGratitude.vue?vue&type=style&index=0&id=3f307dda&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f307dda"]])

export default __exports__